module.exports = "https://r.nearpod.com/assets/media/image/camera-f5a9e7d1586156f51490769058dfad3b.svg";